import { ScrollTop } from '@/components/element/ScrollTop';
import { PurchaseOrderContractTaskEditForm } from '@/components/features/tasks/purchase_order_contract/[purchase_order_contract_task_id]/PurchaseOrderContractTaskEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentPurchaseOrderContractTask } from '@/providers/PurchaseOrderContractTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const BackofficePurchaseOrderContractTaskEdit = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { purchaseOrderContractTask: task } = useCurrentPurchaseOrderContractTask();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('契約申請（費用）タスク編集'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `契約申請（費用）タスク一覧`,
          path: `/w/${_w_!.identifier}/backoffice/purchase_order_contract_tasks`,
        },
        {
          label: `契約申請（費用）タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/purchase_orders/${purchase_order_id}/purchase_order_contract_tasks/${task!.id}`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PurchaseOrderContractTaskEditForm />
    </WorkspaceLayout>
  );
};
